<dx-data-grid style="max-height: 100vh" [class.not-available]="isBusy"
  [dataSource]="dataSource"
  [columns]="columns"
  [rowAlternationEnabled]="true"
  [showBorders]="true"
  [showRowLines]="true"
  [columnAutoWidth]="true"
  (onSaving)="onSaving($event)"
  (onInitNewRow)="onInitNewRow($event)">

  <dxo-editing mode="batch" [allowAdding]="true" [allowUpdating]="false" [allowDeleting]="true" [useIcons]="true"></dxo-editing>
  <dxo-paging [pageSize]="500"></dxo-paging>

  <div *dxTemplate="let cellInfo of 'employeeEditTemplate'">
    <dx-select-box      
      displayExpr="EmployeeNumberAndName"
      searchExpr="EmployeeNumberAndName"
      valueExpr="EmployeeId"
      [dataSource]="{store: employees, paginate: true, pageSize: 10}"
      (onValueChanged)="onEmployeeValueChanged($event, cellInfo)"
      [searchEnabled]="true"
      [height]="35"
      [showClearButton]="true"
      [value]="cellInfo.data.EmployeeId">
      </dx-select-box>
  </div>

  <div *dxTemplate="let cellInfo of 'projectEditTemplate'">
    <dx-select-box          
      displayExpr="ProjectDisplayName"
      searchExpr="ProjectDisplayName"
      valueExpr="ProjectId"
      [dataSource]="projects"
      (onValueChanged)="onProjectValueChanged($event, cellInfo)"
      [searchEnabled]="true"
      [height]="35"
      [showClearButton]="true"
      [placeholder]="languageService.LNG('Label.MinThreeCharacters')"
      [value]="cellInfo.data.CarrierProjectId">
    </dx-select-box>
  </div>

  <div *dxTemplate="let cellInfo of 'machine1EditTemplate'">
    <dx-select-box      
      displayExpr="DisplayName"
      searchExpr="DisplayName"
      valueExpr="EquipmentId"
      [dataSource]="{store: equipment, paginate: true, pageSize: 10}"
      (onValueChanged)="onMachineValueChanged($event, cellInfo)"
      [searchEnabled]="true"
      [height]="35"
      [showClearButton]="true"
      [value]="cellInfo.data.Machine1">
      </dx-select-box>
  </div>

  <div *dxTemplate="let cellInfo of 'machine2EditTemplate'">
    <dx-select-box      
      displayExpr="DisplayName"
      searchExpr="DisplayName"
      valueExpr="EquipmentId"
      [dataSource]="{store: equipment, paginate: true, pageSize: 10}"
      (onValueChanged)="onMachineValueChanged($event, cellInfo)"
      [searchEnabled]="true"
      [height]="35"
      [showClearButton]="true"
      [value]="cellInfo.data.Machine2">
      </dx-select-box>
  </div>

  <div *dxTemplate="let e of 'timeCellTemplate'">
    <span>{{e["data"][e.column.dataField] | timeFormat}}</span>
  </div>

  <div *dxTemplate="let e of 'timeEditTemplate'">
    <app-masked-time-input [(value)]="e['data'][e.column.dataField]" (valueChanged)="onTimeValueChanged($event, e)"></app-masked-time-input>
  </div>

  </dx-data-grid>

  <app-load-panel *ngIf="isBusy"></app-load-panel>